import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../common/html/element'
import { COMPONENTS } from '../../../routers/constants'

export const DetailCell = ({ val }) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(
      COMPONENTS.userManagement.components.subscriptionPayment.components
        .requestDetail.route +
        '?requestId=' +
        val,
    )
  }

  return (
    val && (
      <Element
        elementName="span"
        className="cursorPointer"
        style={{ color: '#2C73E8', whiteSpace: 'nowrap' }}
        onClick={onClick}
      >
        <Translate value="userManagement.packageSubManagement.DETAILS" />
      </Element>
    )
  )
}
